import { useEffect, useState } from 'react';

export default function PrivacyChoices() {
  const [available, setAvailable] = useState(false);
  useEffect(() => {
    let mounted = true;
    window.googlefc = window.googlefc || {};
    window.googlefc.callbackQueue = window.googlefc.callbackQueue || [];
    window.googlefc.callbackQueue.push({ CONSENT_API_READY: () => {
      if (mounted && typeof window.googlefc.showRevocationMessage === 'function') setAvailable(true);
    } });
    return () => { mounted = false; };
  }, []);
  if (!available) return null;
  const openChoices = () => window.googlefc.callbackQueue.push({ CONSENT_API_READY: () => window.googlefc.showRevocationMessage() });
  return <button type="button" onClick={openChoices} className="mr-4 text-gray-400 hover:text-gray-200">Privacy and cookie settings</button>;
}
